import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AppBar, Notice } from "../components/Layout";
import { api } from "../lib/api";

export default function Login() {
  const [passcode, setPasscode] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state && location.state.from;

  // The passcode is checked on the server and exchanged for an httpOnly cookie.
  const handleLogin = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    setError("");
    try {
      const result = await api("session", { method: "POST", body: { passcode } });
      // A staff session can only ever use /staff, so send it there regardless
      // of where it came from. An admin goes back to whatever they asked for.
      const destination = result.role === "staff" ? "/staff" : from || "/admin";
      navigate(destination, { replace: true });
    } catch (err) {
      setError(err.message || "Incorrect passcode");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="vv-page vv-page--paper">
      <AppBar title="Staff" />
      <main className="vv-wrap vv-login">
        <form onSubmit={handleLogin} className="vv-panel vv-login__card">
          <h1 className="vv-display vv-h1 vv-h1--sm">Staff &amp; admin sign in</h1>
          <p className="vv-muted">
            {from === "/staff"
              ? "Enter the staff passcode to see today’s bookings."
              : "Staff passcode for the day’s bookings; admin passcode for the full dashboard."}
          </p>
          <label className="vv-field">
            <span className="vv-field__label">Passcode</span>
            <input
              type="password"
              className="vv-input"
              value={passcode}
              onChange={(e) => setPasscode(e.target.value)}
              required
              autoFocus
              autoComplete="current-password"
            />
          </label>
          {error && <Notice message={error} tone="error" />}
          <button type="submit" className="vv-btn vv-btn--strong vv-btn--block" disabled={submitting}>
            {submitting ? "Checking…" : "Sign in"}
          </button>
          <Link to="/" className="vv-backlink">← Back to the website</Link>
        </form>
      </main>
    </div>
  );
}
